module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_piolink_m.1455abf6b75fdd3e42a4849b41082ec6.png";